import { useEffect } from 'react';

export function usePageTitle(title) {
  useEffect(() => {
    document.title = title ? `TOROS ERP - ${title}` : 'TOROS ERP';
  }, [title]);
}
